import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Home',
		component: () => import('../views/Home.vue'),
	},
	{
		path: '/team',
		name: 'team',
		component: () => import('../views/team.vue'),
	},
	{
		path: '/welfare',
		name: 'welfare',
		component: () => import('../views/welfare.vue'),
	},
	{
		path: '/about',
		name: 'about',
		component: () => import('../views/About.vue'),
	},
]

const router = new VueRouter({
	routes,
})

export default router
